import React from 'react';
import {Fragment } from 'react'; 

import { auth } from '../../firebase';
import { Button } from 'reactstrap';
import {compose} from 'recompose';
import { inject, observer } from 'mobx-react';
import './index.css';

const SignOutButton = ({sessionStore}) => {

  var usernName = sessionStore.authUser.displayName;

  return (<Fragment>
    <span className='pr-3 signOutBtn'>{usernName}</span>
    <Button onClick={auth.doSignOut}>
      Atsijungti
    </Button>
  </Fragment>)
}


export default compose(
  inject('sessionStore'),
  observer
)(SignOutButton);



// WEBPACK FOOTER //
// ./src/components/SignOut/index.js